/* Deals pages: keep the shopper's tier for the visit and the band's sale tag on the Central calendar.
   The pure contract loads in Node without reading browser globals. */
(() => {
  'use strict';

  function calendarTime(iso) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(iso)) return NaN;
    const time = Date.parse(iso + 'T00:00:00Z');
    return Number.isFinite(time) && new Date(time).toISOString().slice(0, 10) === iso ? time : NaN;
  }

  function daysLeft(todayISO, endISO) {
    return (calendarTime(endISO) - calendarTime(todayISO)) / 86400000;
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { daysLeft };
    return;
  }
  if (typeof document === 'undefined') return;

  function init(root) {
    if (root.dataset.dealsReady === 'true') return;
    root.dataset.dealsReady = 'true';
    // Owner 2026-11-01: keep the shopper's tier for this visit; the main deals collection forwards to it.
    try { if (root.dataset.dealsTier) sessionStorage.setItem('dmDealsTier', root.dataset.dealsTier); } catch (_) { /* private mode */ }
    // The sale tag lives in the band, beside this header in the same section.
    const scope = (root.closest && root.closest('.shopify-section')) || root;
    recount(scope);
    // Codex re-check 11/1: a page restored from the back-forward cache, or a tab left open past midnight, recounts
    // when it shows again.
    window.addEventListener('pageshow', event => { if (event.persisted) recount(scope); });
    document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') recount(scope); });
  }

  function recount(scope) {
    try {
      const parts = new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/Chicago', year: 'numeric', month: '2-digit', day: '2-digit'
      }).formatToParts(new Date());
      const part = type => parts.find(entry => entry.type === type).value;
      const today = part('year') + '-' + part('month') + '-' + part('day');
      scope.querySelectorAll('[data-deals-end]').forEach(band => {
        const days = daysLeft(today, band.dataset.end);
        if (!Number.isFinite(days)) return;
        // A cached page can outlive the sale: the tag and the date line go once it has ended.
        const ended = days < 0;
        band.classList.toggle('dh-band__inner--no-count', ended);
        band.querySelectorAll('[data-deals-count], [data-deals-date]').forEach(el => { el.hidden = ended; });
        if (ended) return;
        const words = days === 0 ? band.dataset.leftToday : days === 1 ? band.dataset.leftOne : band.dataset.leftMany;
        const number = days >= 2 ? String(days) : '';
        const num = band.querySelector('[data-deals-num]');
        const left = band.querySelector('[data-deals-days]');
        const tag = band.querySelector('.dh-tag');
        const sentence = band.querySelector('[data-deals-sentence]');
        if (num && num.textContent !== number) num.textContent = number;
        if (left && left.textContent !== words) left.textContent = words;
        if (tag) tag.classList.toggle('dh-tag--words', !number);
        if (sentence) sentence.textContent = (number ? number + ' ' : '') + words + '.';
      });
    } catch (_) { /* Keep the server's Central-time label when Intl is unavailable. */ }
  }

  const boot = () => document.querySelectorAll('[data-deals-header]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
